export default {
	sec_01: {
		title: {
			one: 'オンラインおよび',
			two: '対面決済',
			three: 'の承諾',
		},
		btn: {
			one: '会員登録',
			two: '営業チームに問い合わせ',
		},
	},
	sec_14: {
		btn: '始めるためにアカウントの専門家にお問い合わせてください ',
	},
	sec_03: {
		title: {
			one: '競争優位を確保',
		},
		desc: {
			one: '私たちは、小企業がどんな状況でも支払いを受けることをお手伝い致します。',
		},
		one: {
			title: {
				one: 'お客様が求める',
				two: '柔軟性',
			},
			desc: {
				one: 'お客様が後払いをされるか、定期購入に登録するか、',
				two: 'グローバルまたはローカルの決済オプションをご利用ください。',
			},
		},
		two: {
			title: {
				one: '世界中の購買者と繋がります。',
			},
			desc: {
				one: 'すべての暗号資産を使って、オンラインまたは店舗で',
				two: '支払いを受け入れます。',
			},
		},
		three: {
			title: {
				one: 'オンライン決済',
				two: 'の承諾',
			},
			desc: {
				one: 'お客様がお好みの方法でお支払いいただき、',
				two: '素早く決済ができるようにします。 こちら からオンライン',
				three: '決済を承諾する方法の詳細をご覧ください。',
			},
		},
	},
	sec_15: {
		title: {
			one: 'Introducing the benefits of JP WORLD Pay.',
		},
		cards: {
			one: {
				title: {
					one: 'オンラインチェックアウト',
				},
				description: {
					one: 'お客様は単一ソリューションでサイト、',
					two: 'モバイル、またはアプ',
					three: 'リで様々な決済手段が ご利用できます。',
				},
				btn_01: {
					one: 'オンラインチェックアウトの',
					two: '詳細',
				},
				btn_02: {
					one: 'サブスクリプションサービス',
					two: 'の詳細',
				},
			},
			two: {
				title: {
					one: '請求書と見積もり',
				},
				description: {
					one: 'お客様が簡単に支払うことのできるカスタマイズされた無料の',
					two: '請求書を送ることによって、',
					three: '支払いを促すことができます。',
				},
				btn: {
					one: '請求書発行に関す',
					two: 'る詳細',
				},
			},
			three: {
				title: {
					one: 'ソーシャルでの販売',
				},
				description: {
					one: '色んなソーシャルメディアプラットフォームで、',
					two: 'JP WORLD PAY決済',
					three: 'システムを使用して 支払いを受け取ることができます。',
				},
				btn: {
					one: 'ソーシャルでの販売',
					two: 'の詳細',
				},
			},
			four: {
				title: {
					one: 'オンライン暗号資産決済',
					two: 'システム',
				},
				description: {
					one: 'JP WORLD PAYのクレジット及びオンライン決済サービスにより、',
					two: '主要な暗号資産でのオンライン及び店舗内の支払いを受け入れ',
					three: 'ることができます。',
				},
			},
			five: {
				title: {
					one: '対面での決済の承諾',
				},
				description: {
					one: 'お客様が直接買い物中に費用を支払うことができます。',
					two: 'ここでの仕組みを学びます。',
				},
			},
			six: {
				title: {
					one: '販売ポイント',
				},
				description: {
					one: 'すべての人気のある決済タイプを受け入れ、',
					two: '販売を追跡し、完全なPOSソリューションである',
					three: 'JP WORLD PAY Settingでビジネス',
					four: 'を管理しましょう。',
				},
				btn: {
					one: 'JP WORLD PAY Setting',
					two: 'の詳細',
				},
			},
		},
	},
	common: {
		coming_soon: '準備中です。',
	},
};
